export const getInitialState = (): any => ({
  dataProcessingGroupByStatusData: {}
});
